import { type components } from 'api/playerPayback/api'
import { bool, object, string } from 'yup'

export type LeUserRoleType =
  components['schemas']['LicensedEstablishmentUserRoleType']

export const LeUserRoles: Array<LeUserRoleType | undefined> = [
  'Owner',
  'Staff',
  'SalesAccountManager',
  'SalesServiceRep',
  'JJEmployee',
]

export const LEUserRoleAndPermissionSchema = object({
  type: string()
    .oneOf(LeUserRoles)
    .nullable()
    .test((value) => value !== undefined && value !== null),
  allPermissions: bool(),
  staffPermissions: bool(),
  salesAccountManagerPermissions: bool(),
  salesServiceRepPermissions: bool(),
  jjEmployeePermissions: bool(),
  flexPayPermission: bool().required(),
  compliancePermission: bool().required(),
  gamingReportsPermission: bool().required(),
  playerPaybackPermission: bool().required(),
  patronCheckInsPermission: bool().required(),
  rewardsPermission: bool().required(),
  promotionsPermission: bool().required(),
  sweepstakesPermission: bool().required(),
  enrollInSweepstakesPermission: bool().required(),
  locationSweepstakesPermission: bool().required(),
  playerPaybackReportsPermission: bool().required(),
  locationsPermission: bool().required(),
  leUsersPermission: bool().required(),
  contactUsPermission: bool().required(),
  reportsAccessToPIIPermission: bool().required(),
  reportsDownloadPIIPermission: bool().required(),
  badgeRewardsPermission: bool().required(),
  badgeLocationsPermission: bool().required(),
})
